import Button from "@pathwright/ui/src/components/button/Button"
import Text from "@pathwright/ui/src/components/ui/Text"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { useState } from "react"
import styled from "styled-components"
import { useCreateStoreLinkMutation, useStoreQuery } from "@pathwright/graphql-client/src/generated"
import {
  SchoolLicensePickerDropdown,
  useUserSchoolLicenseQuery
} from "./SchoolLicensePicker"
import SignupFauxLoading from "./SignupFauxLoading"
import SignupSchoolForm from "./SignupSchoolForm"

const PickerContainer = styled.div`
  position: relative;
  padding: 2em 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const SignupSelectSchool = ({
  renderHeader,
  renderSubmit,
  licensorId,
  namePlaceholder,
  utmParameters,
  copy,
  onSchoolCreated,
  onSchoolSelected,
  onSchoolLinked,
  inverted,
  onNext
}) => {
  const [showSchoolLicensePicker, setShowSchoolLicensePicker] = useState(false)
  const [schoolToLink, setSchoolToLink] = useState(null)
  const { t } = useTranslate()

  const [createStoreLink] = useCreateStoreLinkMutation({
    onCompleted: ({ createStoreLink }) =>
      onSchoolLinked && onSchoolLinked(createStoreLink.licensee)
  })

  const storeQuery = useStoreQuery()
  const userSchoolLicenseQuery = useUserSchoolLicenseQuery()
  const storeAvailable = !!storeQuery.data && !!storeQuery.data.store
  const curriculumSubscriptionAvailable = !!licensorId
  const userIsAdminOfOtherSchools = !!userSchoolLicenseQuery.schools.length

  return schoolToLink ? (
    <SignupFauxLoading linkedSchool={schoolToLink} inverted={inverted} />
  ) : (
    <>
      <SignupSchoolForm
        renderHeader={renderHeader}
        renderSubmit={renderSubmit}
        licensorId={licensorId}
        namePlaceholder={namePlaceholder}
        utmParameters={utmParameters}
        copy={copy}
        onSchoolCreated={onSchoolCreated}
        inverted={inverted}
        onNext={onNext}
      />
      {userIsAdminOfOtherSchools &&
        (curriculumSubscriptionAvailable || storeAvailable) && (
          <PickerContainer>
            <Button
              styleType="text"
              inverted={inverted}
              brand
              onClick={() => setShowSchoolLicensePicker(true)}
            >
              <Text.H5 inverted={inverted} brand>
                {t("or link to an existing Pathwright Account")}
              </Text.H5>
            </Button>
            {showSchoolLicensePicker ? (
              curriculumSubscriptionAvailable ? (
                <SchoolLicensePickerDropdown
                  searchPrompt={null}
                  onOutsideClick={() => setShowSchoolLicensePicker(false)}
                  getPickerItem={(school) => ({
                    ...school,
                    meta:
                      school.curriculum_subscriptions.total >= 1
                        ? t("Already linked")
                        : null
                  })}
                  onPick={(school) => {
                    if (school.curriculum_subscriptions.total === 0) {
                      onSchoolSelected && onSchoolSelected(school)
                    }
                  }}
                />
              ) : (
                <SchoolLicensePickerDropdown
                  searchPrompt={null}
                  onOutsideClick={() => setShowSchoolLicensePicker(false)}
                  getPickerItem={(school) => ({
                    ...school,
                    meta:
                      school.storeLinks.total >= 1 ? t("Already linked") : null
                  })}
                  onPick={(school) => {
                    if (school.storeLinks.total === 0) {
                      onSchoolSelected && onSchoolSelected(school)
                      setSchoolToLink(school)
                      createStoreLink({
                        variables: {
                          schoolId: school.id,
                          copy
                        }
                      })
                    }
                  }}
                />
              )
            ) : null}
          </PickerContainer>
        )}
    </>
  )
}

SignupSelectSchool.displayName = "SignupSelectSchool"

export default SignupSelectSchool
